import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class FloatingPanelAPI extends ComponentAPI {
    getHeight() {
        return this.state.height;
    }
    setHeight(height) {
        this.setState({ height });
    }
    getInitialPosition() {
        return this.state.initialPosition;
    }
    setInitialPosition(initialPosition) {
        this.setState({ initialPosition });
    }
    getMaxHeight() {
        return this.state.maxHeight;
    }
    setMaxHeight(maxHeight) {
        this.setState({ maxHeight });
    }
    getMaxWidth() {
        return this.state.maxWidth;
    }
    setMaxWidth(maxWidth) {
        this.setState({ maxWidth });
    }
    getMinHeight() {
        return this.state.minHeight;
    }
    setMinHeight(minHeight) {
        this.setState({ minHeight });
    }
    getMinWidth() {
        return this.state.minWidth;
    }
    setMinWidth(minWidth) {
        this.setState({ minWidth });
    }
    getWidth() {
        return this.state.width;
    }
    setWidth(width) {
        this.setState({ width });
    }
    getPosition() {
        return this.state.position;
    }
    setPosition(position) {
        this.setState({ position });
    }
}
export default FloatingPanelAPI;
//# sourceMappingURL=floating-panel-api.js.map